import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const SportScalePrimaryButton = ({ className, children, ...restProps }) => {
  const classes = useStyles();

  return (
    <Button variant="contained" color="primary" className={classNames(classes.root, className)} {...restProps}>
      {children}
    </Button>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    borderRadius: '0.2rem',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.main,
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.main,
    },
    '&:focus': {
      boxShadow: 'none',
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.main,
    },
    '&:disabled': {
      boxShadow: 'none',
      backgroundColor: theme.palette.grey[500],
    },
  },
}));

SportScalePrimaryButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
};

SportScalePrimaryButton.defaultProps = {
  className: null,
};

export default SportScalePrimaryButton;
